<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editHoliday" />
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                    svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteHoliday" />
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo"  title="Thông tin nghỉ lễ" :active.sync="openHolidayDetails" v-if="openHolidayDetails" id="details-holiday">
            <HolidayInfo :holidayId="params.data.id"></HolidayInfo>
        </vs-popup>
    </div>
</template>

<script>

import { isAPI, isRouter } from '../../../../store/permission';
import { constAPI, constRouter } from '../../../../store/constant';
import HolidayInfo from "../HolidayInfo";

export default {
    name: 'CellRendererActions',
    components: {
        HolidayInfo
    },
    data() {
        return {
            userInfo: {},
            openHolidayDetails: false,
        }
    },
    created() {
        let userInfo = JSON.parse(localStorage.getItem('userInfo') || {});
        this.userInfo = userInfo;
    },
    methods: {
        isPermissionUpdate() {
            return isRouter(this, constRouter.holiday_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.holiday_delete)
        },
        editHoliday() {
            // this.$router.push(`/user/manage-holiday-info?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`)
            //     .catch(() => {
            //     })
            this.openHolidayDetails = true;
        },

        confirmDeleteHoliday() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá ngày lễ này không ?`,
                accept: this.deleteHoliday,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteHoliday() {
            this.$vs.loading();
            this.$crm.post('/holiday/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.$store.commit('UPDATE_HOLIDAY', true);
                this.showDeleteSuccess();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá ngày lễ thành công!',
                iconPack: 'feather',
                icon: 'icon-check-circle',
            })
        }
    },

    mounted() {
        this.$eventBus.$on('update-holiday-success', () => {
            this.openHolidayDetails = false;
            this.$store.commit('UPDATE_HOLIDAY', true);
        })
    }
}
</script>

<style lang="scss">
#details-holiday {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>
